var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.192 7.635-9.918 9.579a1 1 0 0 0-.294.574l-.248 1.696a.5.5 0 0 0 .654.546l1.502-.505a1 1 0 0 0 .376-.229l10-9.659-2.048-1.978zm1.438-1.39 2.048 1.978.025.024 2.354-2.273a1.44 1.44 0 1 0-2.001-2.072z",
    clipRule: "evenodd"
  })));
});
const SvgEditFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4xOTE1IDcuNjM0ODZMNC4yNzQ0IDE3LjIxMzZDNC4xMTUyNyAxNy4zNjczIDQuMDExNiAxNy41Njk1IDMuOTc5NjMgMTcuNzg4NEwzLjczMjAyIDE5LjQ4MzZDMy42NzgxMiAxOS44NTI3IDQuMDMyNjcgMjAuMTQ4NyA0LjM4NjE4IDIwLjAyOThMNS44ODc5NiAxOS41MjQ2QzYuMDI4NjggMTkuNDc3MyA2LjE1NzA5IDE5LjM5OTIgNi4yNjM4OCAxOS4yOTYxTDE2LjI2MzggOS42MzczTDE0LjIxNiA3LjY1OTMyQzE0LjIwNzcgNy42NTEyNyAxNC4xOTk1IDcuNjQzMTIgMTQuMTkxNSA3LjYzNDg2Wk0xNS42MzA1IDYuMjQ0OTdMMTcuNjc4MiA4LjIyMjhDMTcuNjg2NiA4LjIzMDkgMTcuNjk0OCA4LjIzOTEgMTcuNzAyOCA4LjI0NzQxTDIwLjA1NjcgNS45NzM3OUMyMC42NDI5IDUuNDA3NjcgMjAuNjQyOSA0LjQ2ODQyIDIwLjA1NjcgMy45MDIzQzE5LjQ5ODcgMy4zNjMzIDE4LjYxNCAzLjM2MzMgMTguMDU1OSAzLjkwMjNMMTUuNjMwNSA2LjI0NDk3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";